/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { navigateRoutes } from '../../_config/route';
import {
  export_all_admin_contacts_action,
  export_selected_user_contacts_action,
  export_user_contacts_action,
  fetch_all_admin_contacts_action,
  fetch_user_contacts_action,
} from '../../_redux/action';
import { AuthContext } from '../../_hooks/useAuthContext';
import { platformRoles } from '../../_helpers/types';

function useSavedContacts(props) {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [allContacts, setAllContacts] = useState();
  const [contactModalOpen, setContactModalOpen] = useState(null);
  const [deleteContact, setDeleteContact] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(null);
  const [exportUserIds, setExportUserIds] = useState([]);
  const [sortKey, setSortKey] = useState(null);
  const [sortOrder, setSortOrder] = useState();
  const [sortModalOpen, setSortModalOpen] = useState(false);
  const [selectedContactId, setSelectedContactId] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { contactsData } = useSelector((state) => state.fetch_user_contacts_reducer);
  const { allContactsData } = useSelector((state) => state.fetch_all_admin_contacts_reducer);

  useEffect(() => {
    if (user) {
      callAllContactsApi();
    }
  }, [user]);

  useEffect(() => {
    if (contactsData) {
      setAllContacts(contactsData);
    }
  }, [contactsData]);

  useEffect(() => {
    if (allContactsData) {
      setAllContacts(allContactsData);
    }
  }, [allContactsData]);

  const callAllContactsApi = async () => {
    setLoading(true);
    if (user?.role === platformRoles.admin) {
      await dispatch(fetch_all_admin_contacts_action());
    } else {
      await dispatch(fetch_user_contacts_action());
    }
    setLoading(false);
  };

  const handleContactModalOpen = (item) => {
    if (item) {
      setSelectedContactId(item._id);
    }
    if (contactModalOpen) {
      callAllContactsApi();
    }
    setContactModalOpen((v) => !v);
  };

  const onContactDelete = async (item) => {
    setDeleteContact(item);
    setDeleteModalOpen((v) => !v);
  };
  const handleDeleteModalOpen = (item) => {
    if (item) {
      setDeleteContact(item);
    }
    if (deleteModalOpen) {
      callAllContactsApi();
    }
    setDeleteModalOpen((prev) => !prev);
  };

  const onSelectExportClick = (item) => {
    if (exportUserIds.includes(item._id)) {
      setExportUserIds(exportUserIds.filter((id) => id !== item._id));
    } else {
      setExportUserIds([...exportUserIds, item._id]);
    }
  };

  const onExportButtonClick = () => {
    if (exportUserIds.length === 0) {
      if (user?.role === platformRoles.admin) {
        dispatch(export_all_admin_contacts_action());
      } else {
        dispatch(export_user_contacts_action());
      }
    } else {
      dispatch(export_selected_user_contacts_action({ export_ids: exportUserIds }));
    }
  };

  const onSortUserContact = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortOrder('asc');
    }
    if (key) {
      if (key === 'company_id') {
        setAllContacts(
          allContacts.sort((a, b) =>
            sortOrder === 'asc' ? a[key].name.localeCompare(b[key].name) : b[key].name.localeCompare(a[key].name)
          )
        );
      } else {
        setAllContacts(
          allContacts.sort((a, b) =>
            sortOrder === 'asc' ? a[key].localeCompare(b[key]) : b[key].localeCompare(a[key])
          )
        );
      }
    }
    setSortModalOpen(false);
  };

  const handleSortModalOpen = () => {
    setSortModalOpen((v) => !v);
  };

  const onSearchChange = (e) => {
    const searchTerm = e.target.value.toLowerCase();

    if (searchTerm.length > 1) {
      setLoading(true);
      const filteredContacts = (contactsData || allContactsData).filter(
        (contact) =>
          contact.name.toLowerCase().startsWith(searchTerm) ||
          (contact.company_id && contact.company_id.name.toLowerCase().startsWith(searchTerm)) ||
          (contact.job_title && contact.job_title.toLowerCase().startsWith(searchTerm)) ||
          (contact.category_ids && contact.category_ids.some((id) => id.title.toLowerCase().startsWith(searchTerm)))
      );
      setAllContacts(filteredContacts);
      setLoading(false);
    } else {
      setAllContacts(allContactsData || contactsData);
      setLoading(false);
    }
  };

  const onSelectAllClick = (e) => {
    if (e.target.checked) {
      setExportUserIds(allContacts.map((contact) => contact._id));
    } else {
      setExportUserIds([]);
    }
  };

  const onContactViewClick = (id) => {
    navigate(navigateRoutes.viewContact.replace(':id', id));
  };

  return {
    user,
    loading,
    allContacts,
    contactModalOpen,
    deleteContact,
    deleteModalOpen,
    exportUserIds,
    sortModalOpen,

    onContactDelete,
    handleContactModalOpen,
    onContactViewClick,
    onSelectExportClick,
    onExportButtonClick,
    onSortUserContact,
    handleSortModalOpen,
    onSearchChange,
    onSelectAllClick,
    selectedContactId,
    handleDeleteModalOpen,
  };
}
export default useSavedContacts;
